<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <a
                href="javascript:void(0)"
                @click="$router.go(-1)"
              ><CIcon
                name="cil-arrow-left"
                class="mr-2"
              />Voltar</a>
            </div>
          </CCol>
        </CRow>

        <!-- Title -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              {{ $route.params.id ? 'Editar Institucional' : 'Cadastrar Institucional' }}
            </h4>

            <div class="d-flex align-items-center">
              <div class="ml-2 d-flex align-items-center">
                <label class="mb-0">
                  <b>Status</b>
                </label>
                <CSwitch
                  type="checkbox"
                  color="success"
                  variant="3d"
                  class="mx-2"
                  v-bind="labelIcon"
                  :checked.sync="form.status"
                />
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Fields -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0 d-flex align-items-center">
              <CIcon
                name="cil-justify-center"
                class="mt-md-1 mr-2"
              />
              Informações
              <img
                v-if="languageFlag"
                :src="require(`@/assets/img/flags/${languageFlag}.svg`)"
                alt="Bandeira do idioma"
                class="flag ml-2 mt-sm-1"
              />
            </h5>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <!-- Language -->
              <CCol lg="6">
                <div class="form-group">
                  <label for="">Idioma*</label>

                  <Multiselect
                    :value="languageTargetOptions.find(option => option.value == form.language_id)"
                    :options="languageTargetOptions"
                    label="label"
                    track-by="value"
                    :disabled="true"
                    @select="(selected) => form.language_id = selected.value"
                  />
                </div>
              </CCol>

              <!-- Title -->
              <CCol lg="6">
                <CInput
                  v-model="form.title"
                  label="Título*"
                  placeholder="Título"
                  :disabled="true"
                  required
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Grupo Intelli -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon
                name="cil-justify-center"
                class="mb-1 mr-2"
              />
              Grupo Intelli
            </h5>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="12">
                <div class="form-group">
                  <label for="text-institucional">Texto</label>

                  <TextEditor
                    id="text-institucional"
                    v-model="form.text"
                    type="simpletext"
                    :disabled="processing"
                  />
                </div>
              </CCol>

              <CCol col="12">
                <div class="form-group">
                  <FileUploader
                    id="image-institutional"
                    :uploader-info="{ label: 'Imagem'}"
                    :enable-multiple="false"
                    :enable-crop-on-uploader="true"
                    :enable-edit-on-api-table="false"
                    :max-files="1"
                    :accept-types="acceptTypes"
                    :extensions="extensions"
                    :medias="form.main_image"
                    :min-cropped-width="423"
                    :min-cropped-height="333"
                    uploader-type="banner"
                    :disabled="processing"
                  />
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Informações Institucionais -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon
                name="cil-justify-center"
                class="mb-1 mr-2"
              />
              Informações Institucionais
            </h5>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="12">
                <CInput
                  v-model="form.video"
                  description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                  :disabled="processing"
                  type="url"
                >
                  <template #label>
                    <label>Vídeo <small class="text-muted">(URL Youtube)</small></label>
                  </template>
                </CInput>
              </CCol>

              <CCol col="12">
                <div class="form-group">
                  <label for="mission">Missão</label>

                  <TextEditor
                    id="mission"
                    v-model="form.mission"
                    type="simpletext"
                    :disabled="processing"
                  />
                </div>
              </CCol>

              <CCol col="12">
                <div class="form-group">
                  <label for="vision">Visão</label>

                  <TextEditor
                    id="vision"
                    v-model="form.vision"
                    type="simpletext"
                    :disabled="processing"
                  />
                </div>
              </CCol>

              <CCol col="12">
                <div class="form-group">
                  <label for="values">Valores</label>

                  <TextEditor
                    id="values"
                    v-model="form.values"
                    type="simpletext"
                    :disabled="processing"
                  />
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Unidades -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon
                name="cil-justify-center"
                class="mb-1 mr-2"
              />
              Unidades
            </h5>
          </CCardHeader>

          <CCardBody>
            <div class="form-group">
              <FileUploader
                id="unit-image"
                :uploader-info="{ label: 'Imagens'}"
                :enable-multiple="true"
                :enable-crop-on-uploader="true"
                :enable-edit-on-api-table="true"
                :max-files="25"
                :accept-types="acceptTypes"
                :extensions="extensions"
                :medias="form.medias"
                :min-cropped-height="318"
                :min-cropped-width="570"
                uploader-type="banner"
                :disabled="processing"
              />
            </div>
          </CCardBody>
        </CCard>

        <!-- Arquivos -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon
                name="cil-justify-center"
                class="mb-1 mr-2"
              />
              Arquivos
            </h5>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="12">
                <div class="form-group">
                  <FileUploader
                    id="code-conduct"
                    :uploader-info="{
                      label: 'Código de Conduta'
                    }"
                    :enable-multiple="false"
                    :enable-crop-on-uploader="false"
                    :enable-edit-on-api-table="false"
                    :max-files="1"
                    :accept-types="acceptTypesFiles"
                    :extensions="extensionsFiles"
                    :medias="form.code_of_conduct"
                    :disabled="processing"
                  />
                </div>
              </CCol>

              <CCol col="12">
                <div class="form-group">
                  <FileUploader
                    id="compliance"
                    :uploader-info="{
                      label: 'Política de Compliance'
                    }"
                    :enable-multiple="false"
                    :enable-crop-on-uploader="false"
                    :enable-edit-on-api-table="false"
                    :max-files="1"
                    :accept-types="acceptTypesFiles"
                    :extensions="extensionsFiles"
                    :medias="form.compliance_policy"
                    :disabled="processing"
                  />
                </div>
              </CCol>

              <CCol col="12">
                <div class="form-group">
                  <FileUploader
                    id="energy-management-policy"
                    :uploader-info="{
                      label: 'Política de Gestão Energética'
                    }"
                    :enable-multiple="false"
                    :enable-crop-on-uploader="false"
                    :enable-edit-on-api-table="false"
                    :max-files="1"
                    :accept-types="acceptTypesFiles"
                    :extensions="extensionsFiles"
                    :medias="form.energy_management_policy"
                    :disabled="processing"
                  />
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            href="javascript:void(0)"
            class="mr-3"
            @click="clearEdit"
          >Limpar alterações</a>
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import TextEditor from '@/components/ui/TextEditor'
import Multiselect from '@/components/ui/Multiselect'
import CardLog from '@/components/ui/CardLog'

import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/institutional.service'

export default {
  metaInfo: {
    title: 'Institucional',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_institutionals')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    TextEditor,
    Multiselect,
    CardLog
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        status: true,
        id: '',
        title: '',
        text: '',
        video: '',
        mission: '',
        vision: '',
        values: '',
        language_id: '',
        main_image: [],
        medias: [],
        code_of_conduct: [],
        compliance_policy: [],
        energy_management_policy: []
      },
      form: {},
      languageTargetOptions: [
        {
          value: '1',
          label: 'Português'
        },
        {
          value: '2',
          label: 'Inglês'
        },
        {
          value: '3',
          label: 'Espanhol'
        }
      ],
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      uploaderInfo: {
        label: 'Imagem'
      },
      acceptTypesFiles: 'pdf',
      extensionsFiles: 'pdf',
      hasLinkOptions: [
        {
          value: '0',
          label: 'Não'
        },
        {
          value: '1',
          label: 'Sim'
        }
      ],
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: ''
    }
  },

  computed: {
    languageFlag() {
      const languageId = parseInt(this.form.language_id)

      if (languageId === 1) {
        return 'pt-br'
      } else if (languageId === 2) {
        return 'en'
      } else if (languageId === 3) {
        return 'es'
      } else {
        return null
      }
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            title: data.title,
            text: data.text,
            video: data.video,
            mission: data.mission,
            vision: data.vision,
            values: data.values,
            status: !!data.status,
            language_id: data.language_id,
            main_image: data.main_image,
            medias: data.medias,
            code_of_conduct: data.code_of_conduct,
            compliance_policy: data.compliance_policy,
            energy_management_policy: data.energy_management_policy
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    clearEdit() {
      this.form = cloneDeep(this.item)
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        title: this.form.title,
        text: this.form.text,
        video: this.form.video,
        mission: this.form.mission,
        vision: this.form.vision,
        values: this.form.values,
        status: this.form.status,
        medias: this.form.medias.map((media) => media.id),
        main_image_id:
          this.form.main_image && this.form.main_image.length > 0
            ? this.form.main_image[0].id
            : null,
        code_of_conduct_id:
          this.form.code_of_conduct && this.form.code_of_conduct.length > 0
            ? this.form.code_of_conduct[0].id
            : null,
        compliance_policy_id:
          this.form.compliance_policy && this.form.compliance_policy.length > 0
            ? this.form.compliance_policy[0].id
            : null,
        energy_management_policy_id:
          this.form.energy_management_policy &&
          this.form.energy_management_policy.length > 0
            ? this.form.energy_management_policy[0].id
            : null
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Institucional foi atualizado com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: true
        }

        this.clearEdit()
        setTimeout(() => {
          this.processing = false
          this.modal.show = false
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 3000)
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
